module.exports = __webpack_public_path__ + "img/BC928D_F9E2D6_654445_835A51-256px.798b269c.png";